import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { reposApiRef } from './api';
import { rootRouteRef } from './routes';
import { ReposClient } from '@appfolio/backstage-plugin-code-search-common';

export const utilitiesPagePlugin = createPlugin({
  id: 'appfolio-utilities-page',
  apis: [
    createApiFactory({
      api: reposApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ReposClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const UtilitiesPage = utilitiesPagePlugin.provide(
  createRoutableExtension({
    name: 'UtilitiesPage',
    component: () =>
      import('./components/UtilitiesPage').then(m => m.UtilitiesPage),
    mountPoint: rootRouteRef,
  }),
);
